// extracted by mini-css-extract-plugin
module.exports = {"pagePreviewWrapper":"preview_pagePreviewWrapper__27qYj","imgCotainer":"preview_imgCotainer__2rhsb"};